import React from 'react';

type Props = {
  width: number;
  height: number;
  fill?: string;
}

const ConnectorIcon = ({
  width, height, fill,
}: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill={fill}
  >
    <path
      d="M15 12.5V10.8333H16.6667C16.9028 10.8333 17.1007 10.9132 17.2604 11.0729C17.4201 11.2326 17.5 11.4306 17.5 11.6667C17.5 11.9028 17.4201 12.1007 17.2604 12.2604C17.1007 12.4201 16.9028 12.5 16.6667 12.5H15ZM15 15.8333V14.1667H16.6667C16.9028 14.1667 17.1007 14.2465 17.2604 14.4063C17.4201 14.566 17.5 14.7639 17.5 15C17.5 15.2361 17.4201 15.434 17.2604 15.5938C17.1007 15.7535 16.9028 15.8333 16.6667 15.8333H15ZM11.6667 16.6667C11.2083 16.6667 10.816 16.5035 10.4896 16.1771C10.1632 15.8507 10 15.4583 10 15H8.33333V11.6667H10C10 11.2083 10.1632 10.816 10.4896 10.4896C10.816 10.1632 11.2083 10 11.6667 10H14.1667V16.6667H11.6667ZM5.83333 14.1667C4.91667 14.1667 4.13194 13.8403 3.47917 13.1875C2.82639 12.5347 2.5 11.75 2.5 10.8333C2.5 9.91668 2.82639 9.13195 3.47917 8.47918C4.13194 7.8264 4.91667 7.50001 5.83333 7.50001H7.08333C7.43056 7.50001 7.72569 7.37848 7.96875 7.13543C8.21181 6.89237 8.33333 6.59723 8.33333 6.25001C8.33333 5.90279 8.21181 5.60765 7.96875 5.36459C7.72569 5.12154 7.43056 5.00001 7.08333 5.00001H4.16667C3.93056 5.00001 3.73264 4.92015 3.57292 4.76043C3.41319 4.6007 3.33333 4.40279 3.33333 4.16668C3.33333 3.93057 3.41319 3.73265 3.57292 3.57293C3.73264 3.4132 3.93056 3.33334 4.16667 3.33334H7.08333C7.88889 3.33334 8.57639 3.61807 9.14583 4.18751C9.71528 4.75695 10 5.44445 10 6.25001C10 7.05557 9.71528 7.74307 9.14583 8.31251C8.57639 8.88195 7.88889 9.16668 7.08333 9.16668H5.83333C5.375 9.16668 4.98264 9.32987 4.65625 9.65626C4.32986 9.98265 4.16667 10.375 4.16667 10.8333C4.16667 11.2917 4.32986 11.684 4.65625 12.0104C4.98264 12.3368 5.375 12.5 5.83333 12.5H7.5V14.1667H5.83333Z"
      fill={fill}
    />
  </svg>
);

ConnectorIcon.defaultProps = {
  fill: 'var(--connectorColor)',
};

export default ConnectorIcon;
